import { Pipe, PipeTransform } from '@angular/core';
import { Injectable } from '@angular/core';

@Pipe({
  name: 'decimalNumber'
})
@Injectable()
export class GetDecimalNumberPipe implements PipeTransform {
  transform(nb: number) {
    const decimal = String(nb);
    return decimal[decimal.indexOf('.') + 1];
  }
}
